import axios from 'axios';

// Feature flags (propuesta integral Fase 0, doc 08 A.1). El baseURL de axios ya
// incluye el prefijo /{tenant}/.
export default {
  getAll() {
    return axios.get('/features');
  },

  getSchema() {
    return axios.get('/features/schema');
  },

  update(key, payload) {
    return axios.put(`/features/${key}`, payload);
  }
}
